import { css } from 'styled-components'
import { Theme } from '@ct-design/token/theme'
import { DayCellProps, DateDropdownProps, DropdownArrowProps } from './type'
import { DropdownItemProps } from './type'

export const getCalendarWrapperStyles = () => css`
    position: relative;
    width: 100%;
`

export const getDateDropdownStyles = ({
    isOpen,
    error
}: DateDropdownProps) => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-left: ${({ theme }: { theme: Theme }) => theme.spacing[4]};
    padding-right: ${({ theme }: { theme: Theme }) => theme.spacing[4]};
    padding-top: ${({ theme }: { theme: Theme }) => theme.spacing[3]};
    padding-bottom: ${({ theme }: { theme: Theme }) => theme.spacing[3]};
    border: 1px solid
        ${({ theme }: { theme: Theme }) =>
            error
                ? theme.color.text.warning
                : isOpen
                  ? theme.color.border.secondary
                  : theme.color.border.default};
    border-radius: ${({ theme }: { theme: Theme }) => theme.border.radius[6]};
    cursor: pointer;
    background: ${({ theme }: { theme: Theme }) =>
        theme.color.background.neutral};
    transition: all 0.2s ease-in-out;
    height: ${({ theme }: { theme: Theme }) => theme.size[10]};
`

export const getDropdownArrowStyles = ({ isOpen }: DropdownArrowProps) => css`
    transform: ${isOpen ? 'rotate(180deg)' : 'none'};
    transition: transform 0.2s ease-in-out;
`

export const getCalendarPopupStyles = () => css`
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    max-width: 320px;
    max-height: 400px;
    margin-top: ${({ theme }: { theme: Theme }) => theme.spacing[1]};
    background: ${({ theme }: { theme: Theme }) =>
        theme.color.background.neutral};
    border: 1px solid
        ${({ theme }: { theme: Theme }) => theme.color.border.default};
    border-radius: ${({ theme }: { theme: Theme }) => theme.border.radius[4]};
    box-shadow: ${({ theme }: { theme: Theme }) => theme.elevation.bottomE2};
    z-index: ${({ theme }: { theme: Theme }) => theme.zIndex.popOver};
    overflow: hidden;
`

export const getCalendarHeaderStyles = () => css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: ${({ theme }: { theme: Theme }) => theme.spacing[2]};
    border-bottom: 1px solid
        ${({ theme }: { theme: Theme }) => theme.color.border.default};
`

export const getMonthNavButtonStyles = () => css`
    background: none;
    border: none;
    cursor: pointer;
    padding: ${({ theme }: { theme: Theme }) => theme.spacing[1]};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }: { theme: Theme }) => theme.color.text.primary};
    transition: color 0.2s ease-in-out;

    &:hover {
        color: ${({ theme }: { theme: Theme }) => theme.color.text.brand};
    }
`

export const getCalendarGridContainerStyles = () => css`
    padding: ${({ theme }: { theme: Theme }) => theme.spacing[2]};
    max-height: calc(400px - 56px); // Subtract header height
    overflow-y: auto;
`
export const getDropdownListStyles = () => css`
    background-color: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
    max-height: 250px;
    overflow-y: auto;
    width: 100%;
`

export const getDropdownItemStyles = () => css<DropdownItemProps>`
    padding: 8px 16px;
    cursor: pointer;
    background-color: ${({ isSelected }) =>
        isSelected ? 'rgba(0, 0, 0, 0.05)' : 'transparent'};

    &:hover {
        background-color: rgba(0, 0, 0, 0.03);
    }
`
export const getHeaderTextStyles = () => css`
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 4px 8px;
    border-radius: 4px;

    &:hover {
        background-color: rgba(0, 0, 0, 0.03);
    }
`
export const getDropdownContainerStyles = () => css`
    position: relative;
    display: flex;
    gap: 4px;
`

export const getCalendarGridStyles = () => css`
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    gap: ${({ theme }: { theme: Theme }) => theme.spacing[1]};
`

export const getWeekdayHeaderStyles = () => css`
    display: flex;
    align-items: center;
    justify-content: center;
    padding: ${({ theme }: { theme: Theme }) => theme.spacing[1]};
`

export const getDayCellStyles = ({
    isToday,
    isSelected,
    isCurrentMonth,
    isDisabled
}: DayCellProps) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    aspect-ratio: 1;
    cursor: pointer;
    border-radius: ${({ theme }: { theme: Theme }) =>
        theme.border.radius['50P']};
    transition: all 0.2s ease-in-out;

    ${isToday &&
    css`
        background: ${({ theme }: { theme: Theme }) =>
            theme.color.background.brandLightBg};
        color: ${({ theme }: { theme: Theme }) => theme.color.text.brand};
    `}

    ${isSelected &&
    css`
        background: ${({ theme }: { theme: Theme }) =>
            theme.color.background.brand};
        color: ${({ theme }: { theme: Theme }) => theme.color.text.neutral};
    `}

    ${!isCurrentMonth &&
    css`
        color: ${({ theme }: { theme: Theme }) => theme.color.text.disabled};
    `}
    ${isDisabled &&
    css`
        color: ${({ theme }: { theme: Theme }) => theme.color.text.disabled};
        opacity: 0.5;
        cursor: not-allowed;
        pointer-events: none;
    `}

    &:hover {
        background: ${({ theme }: { theme: Theme }) =>
            theme.color.background.brandLightBg};
        color: ${({ theme }: { theme: Theme }) => theme.color.text.brand};
    }
`
